<template>
	<el-dialog
		:visible.sync="visible"
		:close-on-click-modal="false"
		:title="title"
		width="960px"
		id="childMonitoring"
		>
		<div class="divBor">
			<div class="allDiv">
				<div class="header">可选产品</div>
				<div style="height: 525px;overflow-y: auto;">
					<el-input
					  placeholder="请输入"
					  v-model="filterText"
						size="mini"
						style="width: 360px;margin: 10px;"
						clearable
						@clear="clearInitialize">
					</el-input>
					<el-button @click="inputBlur" size="mini">查 询</el-button>
					<div v-for="(item,index) in treeData" style="line-height: 24px;">
						<span @click="getPageBybmcid(item,index,1)" style="margin-left: 6px;cursor: pointer;">
							<i :class="item.elIcon"></i>
							{{item.productClassifyName}}
						</span>
						<el-button type="text" style="margin-left: 6px;" @click="allChange(index,item.childData,1,item.fieldvalue)" v-if="item.childData.length != item.checkList.length && item.elIcon == 'el-icon-caret-bottom' && item.fieldvalue && typeNum == 2">全选</el-button>
						<el-button type="text" style="margin-left: 6px;" @click="allChange(index,item.childData,1,item.fieldvalue)" v-if="item.childData.length != item.checkList.length && item.elIcon == 'el-icon-caret-bottom' && typeNum != 2">全选</el-button>
						<el-button type="text" @click="allChange(index,item.childData,2,item.fieldvalue)" v-if="item.childData.length == item.checkList.length && item.elIcon == 'el-icon-caret-bottom' && item.fieldvalue && typeNum == 2">取消全选</el-button>
						<el-button type="text" @click="allChange(index,item.childData,2,item.fieldvalue)" v-if="item.childData.length == item.checkList.length && item.elIcon == 'el-icon-caret-bottom' && typeNum != 2">取消全选</el-button>

						<div v-if="typeNum == 2">
							<el-select v-model="item.fieldvalue" placeholder="请优先选择关键字品名" size="mini" v-if="item.elIcon == 'el-icon-caret-bottom'" style="margin-left: 24px;margin-bottom: 10px;" @change="fieldChange(index,item.fieldvalue)">
								<el-option
									v-for="a in item.options"
									:key="a.fieldvalue"
									:label="a.fieldname"
									:value="a.fieldvalue">
								</el-option>
							</el-select>
							<el-checkbox-group v-model="item.checkList" v-for="i in item.childData" v-if="item.elIcon == 'el-icon-caret-bottom' && title != '新增活动产品' && item.fieldvalue" style="margin-left: 25px;line-height: 24px;">
								<el-checkbox :label="i.disableShow ? i.allProductName + '（已监控）' : i.allProductName" @change="chooseAlone(i,item.fieldvalue)" :disabled="i.disableShow"></el-checkbox>
							</el-checkbox-group>
							<el-checkbox-group v-model="item.checkList" v-for="i in item.childData" v-if="item.elIcon == 'el-icon-caret-bottom' && title == '新增活动产品' && item.fieldvalue" style="margin-left: 25px;line-height: 24px;">
								<el-checkbox :label="i.allProductName" @change="chooseAlone(i,item.fieldvalue)"></el-checkbox>
							</el-checkbox-group>
						</div>

						<div v-else>
							<el-checkbox-group v-model="item.checkList" v-for="i in item.childData" v-if="item.elIcon == 'el-icon-caret-bottom' && title != '新增活动产品'" style="margin-left: 25px;line-height: 24px;">
								<el-checkbox :label="i.disableShow ? i.allProductName + '（已监控）' : i.allProductName" @change="chooseAlone(i)" :disabled="i.disableShow"></el-checkbox>
							</el-checkbox-group>
							<el-checkbox-group v-model="item.checkList" v-for="i in item.childData" v-if="item.elIcon == 'el-icon-caret-bottom' && title == '新增活动产品'" style="margin-left: 25px;line-height: 24px;">
								<el-checkbox :label="i.allProductName" @change="chooseAlone(i)"></el-checkbox>
							</el-checkbox-group>
						</div>

						<div v-if="item.childData.length == 0 && item.elIcon == 'el-icon-caret-bottom'"
							style="color: rgb(204, 204, 204);margin-left: 24px;height: 30px;"
							v-loading="divLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
							暂无数据
						</div>
						<div>
							<el-button style="margin-left: 22px;" type="text" @click="addMore(index,item.childData,item.pageSize,item)" v-if="item.addMoreShow">更多</el-button>
						</div>
					</div>
				</div>
			</div>
			<div class="smDiv">
				<div class="header">
					已选产品
					<span style="padding-left: 15px;color: #FAAD14;" v-if="this.title != '新增活动产品'">
		        可监控产品数量上限：{{chiLdNum}}/{{allLimitProNum}}
		      </span>
				</div>
				<div style="height: 525px;overflow-y: auto;">
					<div v-for="(item,index) in selectedData" class="selSty">
						<el-tooltip class="item" effect="dark" :content="item.name" placement="top" v-if="item.name.length > 35">
							<div class="ellipsisFont">
								{{item.name}}
							</div>
				    </el-tooltip>
						<div class="ellipsisFont" v-else>
							{{item.name}}
						</div>

						<div style="float: right;">
							<i class="el-icon-circle-close" style="cursor: pointer;" @click="del(index,item.smallName)"></i>
						</div>
					</div>
				</div>

			</div>
		</div>
		<span slot="footer">
			<el-button size="small" class="g-confirm-btn" @click="onComfirm" type="primary">确 定</el-button>
			<el-button size="small" class="g-cancel-btn" @click="visible = false" type="TheCustom">取 消</el-button>
		</span>
	</el-dialog>

</template>

<script>
export default {
	name: 'childMonitoring',

	props: {
	},

	data () {
		return {
			filterText: '',
			visible: false,
			title: '新增监控产品',
			treeData: [],
			selectedData: [],
			allLimitProNum: 0,
			totalNum: 0,
			chiLdNum: 0,
			// 重构树形组件
			treeLoading: true,
			fathData: [],
			page: 50000,
			divLoading: true,
			pageSize: 500,
			typeNum: '',
			classifyid: '',
		}
	},
	methods: {
		getByProduct(index) {
			let params = {
				productClassifyid: this.classifyid,
			}
			fetch({
				url: "/hcm/hcmCustomModel/getByProduct",
				method: "get",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(res => {
				let result = JSON.parse(res);
				if (result.status == "10000") {
					this.treeData[index].options = result.data.product.data
				}
			});
		},

		// 更多
		addMore(index,childData,pageSize,item){
			this.pageSize = pageSize + 500
			this.treeData[index].pageSize = this.pageSize
			this.getPageBybmcid(item,index,2)
		},
		// 删除初始化
		clearInitialize() {
			this.$emit('fatherBlur')
		},
		// 数据搜索
		inputBlur() {
			if (this.filterText == '') {
				this.clearInitialize()
			} else {
				let params = {
					page: this.page,
					productname: this.filterText,
					type: 'add'
				}
				fetch({
					url: "hcm/hcmProduct/getListBybmcid",
					method: "get",
					params: params,
					noFormat: true,
					responseType: "text"
				}).then(result => {
					let res = JSON.parse(result);
					let {data}=res
					if(res.status == '10000'){
						this.treeData = []
						for (let zz in data) {
							data[zz].elIcon = 'el-icon-caret-bottom'
							data[zz].childData = []
							data[zz].checkList = []
							data[zz].pageSize = 500
							data[zz].addMoreShow = false
						}
						this.treeData = data
						let childData = []
						for (let a in data) {
							for (let b in data[a].children) {
								if (data[a].id == data[a].children[b].productClassifyId) {
									this.treeData[a].childData.push({
										id: data[a].children[b].id.split(',')[0],
										productClassifyNameAndProductName: data[a].children[b].id.split(',')[1],
										price: '0',
										allProductName: data[a].children[b].productClassifyName,
										disableShow: data[a].children[b].disableShow
									})
								}
								for (let c in this.selectedData) {
									if (data[a].children[b].productClassifyName == this.selectedData[c].smallName) {
										this.treeData[a].checkList.push(this.selectedData[c].smallName)
									}
								}
							}
						}
					} else {
						this.$message({
							message: res.message,
							type: "error"
						});
					}
				})
			}
		},
		// 下拉框事件
		fieldChange(index,fieldvalue) {
			this.treeData[index].fieldvalue = fieldvalue
		},
		// 点击事件
		chooseAlone(i,fieldvalue) {
			let joinshow = true
			if (this.selectedData.length != 0) {
				for (let a in this.selectedData) {
					if (this.selectedData[a].name === i.productClassifyNameAndProductName) {
						joinshow = false
						this.selectedData.splice(a,1)
					}
				}
			}
			if (this.typeNum == 2) {
				if (joinshow) {
					this.selectedData.push({
						productid: i.id,
						name: i.productClassifyNameAndProductName,
						price: '0',
						smallName: i.allProductName,
						productfield: i[fieldvalue]
					})
				}
			} else {
				if (joinshow) {
					this.selectedData.push({
						productid: i.id,
						name: i.productClassifyNameAndProductName,
						price: '0',
						smallName: i.allProductName
					})
				}
			}
			this.changeNum()
		},
		// 全选
		allChange(index,childData,type,fieldvalue) {
			if (type == 1) {
				this.treeData[index].checkList = []
				for (let a in childData) {
					if (childData[a].disableShow != true) {
						this.treeData[index].checkList.push(childData[a].allProductName)
					}
				}
				if (this.treeData[index].checkList.length != 0) {
					this.handleCheckChange(this.treeData,index,fieldvalue)
				}
			} else {
				// 反选
				if (this.treeData[index].checkList.length != 0) {
					this.treeData[index].checkList.forEach(val=>{
				    let index = this.selectedData.findIndex(item=>item.smallName === val)
				    if(index != -1){
			        this.selectedData.splice(index,1)
				    }
					})
					this.treeData[index].checkList = []
				}
				this.changeNum()
			}
		},
		// 获取详细数据
		getPageBybmcid(item,index,num) {
			this.classifyid = item.id
			this.getByProduct(index)
			if (this.filterText && this.filterText != '') {
				// 搜索不需要调用接口
				if (item.elIcon == 'el-icon-caret-right') {
					this.treeData[index].elIcon = 'el-icon-caret-bottom'
				} else {
					this.treeData[index].elIcon = 'el-icon-caret-right'
				}
			} else {
				this.treeLoading = true
				this.divLoading = true
				if (num == 1) {
					if (item.elIcon == 'el-icon-caret-right') {
						this.treeData[index].elIcon = 'el-icon-caret-bottom'
					} else {
						this.treeData[index].elIcon = 'el-icon-caret-right'
						this.treeData[index].addMoreShow = false
					}
				}
				let params = {
					pageNo: 1,
					pageSize: this.pageSize,
					classifyid: item.id,
					type: 'tree'
				}
				fetch({
					url: "hcm/hcmProduct/getPageByTree",
					method: "get",
					params: params,
					noFormat: true,
					responseType: "text"
				}).then(result => {
					let res = JSON.parse(result);
					let {data}=res
					if(res.status == '10000'){
						this.treeData[index].childData = data.list
						if (this.treeData[index].pageSize > data.total) {
							this.treeData[index].addMoreShow = false
						} else {
							this.treeData[index].addMoreShow = true
						}
						this.divLoading = false
					} else {
						this.$message({
							message: res.message,
							type: "error"
						});
					}
				})
			}
		},
		// 数据处理
		handleCheckChange(data,index,fieldvalue) {
			if (data[index] && data[index].childData) {
				for (let a in data[index].childData) {
					if (data[index].childData[a].disableShow != true) {
						this.selectedData.push({
							productid: data[index].childData[a].id,
							name: data[index].childData[a].productClassifyNameAndProductName,
							price: '0',
							smallName: data[index].childData[a].allProductName,
							productfield: data[index].childData[a][fieldvalue]
						})
					}
				}
			}
			// 已选产品去重
			var kv = {}
			for (var i = 0; i < this.selectedData.length;) {
				if (kv[this.selectedData[i].name + ',' + this.selectedData[i].productid]) {
					this.selectedData.splice(i, 1)
				} else {
					kv[this.selectedData[i].name + ',' + this.selectedData[i].productid] = true
					i++
				}
			}
			this.changeNum()
			if (this.chiLdNum > this.allLimitProNum) {
				this.$message({
          message: '超出可监控产品数量上限',
          type: 'warning'
        });
				return;
			}
    },
		// 可监控产品数量上限
		changeNum() {
			this.chiLdNum = 0
			this.chiLdNum = this.totalNum + this.selectedData.length
			console.log(this.chiLdNum)
			console.log(this.selectedData.length)
		},
		// 父组件触发子组件
		open(typeNum,data,productsData,allLimitProNum,chiLdNum) {
			this.selectedData = []
			for (let zz in data) {
				data[zz].elIcon = 'el-icon-caret-right'
				data[zz].childData = []
				data[zz].checkList = []
				data[zz].pageSize = 500
				data[zz].addMoreShow = false
			}
			this.pageSize = 500
			this.visible = true
			this.treeData = data
			this.allLimitProNum = allLimitProNum

			this.typeNum = typeNum
			console.log(chiLdNum)
			console.log(typeNum)
			console.log(productsData)
			if (!allLimitProNum) {
				this.title = '新增活动产品'
			} else {
				this.title = '新增监控产品'
			}
			// 被删除掉的数据新增监控产品不展示
			if (productsData) {
				this.totalNum = 0
				for (let b in productsData) {
					this.selectedData.push({
						productid: productsData[b].productid,
						name: productsData[b].name,
						price: productsData[b].price,
					})
				}
			} else {
				this.totalNum = chiLdNum
			}
			this.changeNum()
		},

		// 删除
		del(index,smallName) {
			if (index || index == 0) {
				this.selectedData.splice(index,1)
				if (this.treeData.length != 0) {
					for (let c in this.treeData) {
						for (let d in this.treeData[c].checkList) {
							if (smallName == this.treeData[c].checkList[d]) {
								this.treeData[c].checkList.splice(d,1)
							}
						}
					}
				}
			}
			let Keydata = []
			for (let a in this.selectedData) {
				Keydata.push(this.selectedData[a].productid)
			}
			this.changeNum()
		},
		// 确认
		onComfirm() {
			if (this.chiLdNum > this.allLimitProNum) {
				this.$message({
					message: '超出可监控产品数量上限',
					type: 'warning'
				});
				return;
			}
			this.$emit('selectedfirm',this.selectedData);
			this.selectedData = []
			this.visible = false
		}
	},

	computed: {},

	mounted(){
	}
}
</script>

<style lang='scss'>
#childMonitoring {
	.el-checkbox__label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 400px;
	}
	.ellipsisFont {
		float: left;
		width: 400px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		height: 24px;
		line-height: 24px;
	}
	.header{
		padding: 0 0 0 10px;
		line-height: 40px;
		margin: 0;
		background-color: #f6f7fb;
	}
	.divBor {
		height: 565px;
		margin: 10px 0;
		border: 1px solid rgb(217, 217, 217);
	}
	.allDiv {
		float: left;
		width: 459px;
		height: 565px;
		border-right: 1px solid rgb(217, 217, 217);
	}
	.smDiv{
		float: right;
		width: 458px;
		height: 565px
	}
	.selSty {
		padding: 0 11px;
		height: 32px;
		line-height: 32px;
	}
	.selSty:hover {
		background-color: #f6f7fb;
	}
	.el-button--primary {
		color: #FFF;
		background-color: #bda571;
		border-color: #bda571;
	}
	.el-button--primary:hover {
		color: #FFF;
		background-color: #c0ae8a;
		border-color: #c0ae8a;
	}
}
</style>
